import { SVCurrencyInput } from '@/components/core';
import { PROGRAM_SETTINGS } from '@/constants/programSettings';
import { Grid, Stack, Typography } from '@mui/material';

export const ACHControls = () => {
  const {
    PROGRAM_LEVEL_MAX_ACH_CREDIT,
    PROGRAM_LEVEL_MAX_ACH_DEBIT,
    BANK_ACCOUNT_LEVEL_MAX_ACH_CREDIT,
    BANK_ACCOUNT_LEVEL_MAX_ACH_DEBIT,
    TRANSACTION_LEVEL_MAX_ACH_CREDIT,
    TRANSACTION_LEVEL_MAX_ACH_DEBIT,
  } = PROGRAM_SETTINGS.ACH_CONTROLS;

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Typography component="h6" fontWeight="bold" mb={2}>
          Program Level Daily Limits
        </Typography>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="achCreditProgramLimitPerRollingDay"
            label={PROGRAM_LEVEL_MAX_ACH_CREDIT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (24 hour rolling aggregate)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ mt: { xs: 0, md: 6 } }}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="achDebitProgramLimitPerRollingDay"
            label={PROGRAM_LEVEL_MAX_ACH_DEBIT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (24 hour rolling aggregate)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Typography component="h6" fontWeight="bold" mb={2}>
          Bank Account Level Limits
        </Typography>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="achCreditAccountLimitPerCalendarDay"
            label={BANK_ACCOUNT_LEVEL_MAX_ACH_CREDIT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Calendar Day EST Aggregate)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ mt: { xs: 0, md: 6 } }}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="achDebitAccountLimitPerCalendarDay"
            label={BANK_ACCOUNT_LEVEL_MAX_ACH_DEBIT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Calendar Day EST Aggregate)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Typography component="h6" fontWeight="bold" mb={2}>
          Transaction Level Limits
        </Typography>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="achCreditLimitPerTransaction"
            label={TRANSACTION_LEVEL_MAX_ACH_CREDIT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Per Transaction)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ mt: { xs: 0, md: 6 } }}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="achDebitLimitPerTransaction"
            label={TRANSACTION_LEVEL_MAX_ACH_DEBIT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Per Transaction)
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};
